/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostSearchRecentQueriesRequest
 */
export interface PostSearchRecentQueriesRequest {
    /**
     * 検索キーワード（1文字以上）
     * @type {string}
     * @memberof PostSearchRecentQueriesRequest
     */
    searchKeyword: string;
}

export function PostSearchRecentQueriesRequestFromJSON(json: any): PostSearchRecentQueriesRequest {
    return PostSearchRecentQueriesRequestFromJSONTyped(json, false);
}

export function PostSearchRecentQueriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchRecentQueriesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchKeyword': json['search_keyword'],
    };
}

export function PostSearchRecentQueriesRequestToJSON(value?: PostSearchRecentQueriesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'search_keyword': value.searchKeyword,
    };
}

